// extracted by mini-css-extract-plugin
export default {"homeownerDetails":"lA0ROgflUMyJwsSniq6y","infoList":"P4j23nhSd7qM2JyHV16A"};